import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const pageNames: Record<string, string> = {
  '/': 'ホーム',
  '/timeline': 'タイムライン',
  '/record': 'はなす',
  '/settings': '設定',
  '/review': '振り返り',
  '/premium': 'プレミアム',
  '/dictionary': '辞書',
};

function getPageName(pathname: string): string {
  if (pageNames[pathname]) return pageNames[pathname];
  if (pathname.startsWith('/entry/')) return '日記詳細';
  return pathname;
}

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer?.push({
      event: 'virtual_page_view',
      page_path: location.pathname,
      page_title: getPageName(location.pathname),
    });
  }, [location.pathname]);
}
